import { useTranslation } from '@web_opxp/features';
import * as React from 'react';
import ENV from '../../base/env';
import './DeltaBadge.scss';

export interface IDeltaBadgeProps {
  delta: number;
}

const DeltaBadge: React.FC<IDeltaBadgeProps> = ({ delta }) => {
  const { t } = useTranslation();

  if (!delta || delta < 0) {
    return null;
  }
  const label = t('Exercise.PostWorkout.Delta', { delta });
  return (
    <div className="progress-delta">
      <img className="delta-icon" alt="progress delta icon" src={`${ENV.AssetsBaseUrl}/feature/progress-arrow.svg`} />
      <small>{label}</small>
    </div>
  );
};

export default DeltaBadge;
